module.exports = require("/vercel/path0/src/store/createStore")